import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const MenuIcon = forwardRef<SVGSVGElement, IconProps>(function MenuIcon(
  { color, height = 24, width = 25, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.54 8.80965C18.8986 8.80965 20 7.70827 20 6.34965C20 4.99103 18.8986 3.88965 17.54 3.88965C16.1814 3.88965 15.08 4.99103 15.08 6.34965C15.08 7.70827 16.1814 8.80965 17.54 8.80965Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46001 8.80965C7.81863 8.80965 8.92 7.70827 8.92 6.34965C8.92 4.99103 7.81863 3.88965 6.46001 3.88965C5.10139 3.88965 4 4.99103 4 6.34965C4 7.70827 5.10139 8.80965 6.46001 8.80965Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.54 21.1095C18.8986 21.1095 20 20.0081 20 18.6495C20 17.2908 18.8986 16.1895 17.54 16.1895C16.1814 16.1895 15.08 17.2908 15.08 18.6495C15.08 20.0081 16.1814 21.1095 17.54 21.1095Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46001 21.1095C7.81863 21.1095 8.92 20.0081 8.92 18.6495C8.92 17.2908 7.81863 16.1895 6.46001 16.1895C5.10139 16.1895 4 17.2908 4 18.6495C4 20.0081 5.10139 21.1095 6.46001 21.1095Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
